"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APUpload = _interopRequireDefault(require("../APUpload/APUpload"));
require("../APUpload/APUpload.css");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _excluded = ["customClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-image-upload';
var APImageUpload = /*#__PURE__*/function (_React$Component) {
  function APImageUpload() {
    var _this;
    _classCallCheck(this, APImageUpload);
    _this = _callSuper(this, APImageUpload);
    _defineProperty(_this, "onChange", function (e, _ref) {
      var file = _ref.file,
        imgSrc = _ref.imgSrc;
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      var changeFn = onChange || function () {};
      if (file) {
        changeFn(name, {
          file: file,
          imgSrc: imgSrc
        });
        setTimeout(function () {
          return _this.setState({
            imgSrc: imgSrc
          });
        });
      } else {
        _this.setState({
          imgSrc: null
        });
        changeFn(name, null);
      }
    });
    _this.state = {
      imgSrc: null
    };
    return _this;
  }
  _inherits(APImageUpload, _React$Component);
  return _createClass(APImageUpload, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        customClass = _this$props2.customClass,
        otherProps = _objectWithoutProperties(_this$props2, _excluded);
      var imgSrc = this.state.imgSrc;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
      return /*#__PURE__*/_react["default"].createElement(_APUpload["default"], _extends({}, otherProps, {
        customChange: this.onChange,
        label: imgSrc ? t("Choose another image") : t("Place image"),
        customClass: bemClasses(),
        acceptedFiles: '.png, .jpg, .jpeg, .gif'
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(APImageUpload, "defaultProps", {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
});
_defineProperty(APImageUpload, "propTypes", {
  name: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  required: _propTypes["default"].bool
});
APImageUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};
APImageUpload.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  placeholder: _propTypes["default"].string,
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  autoFocus: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(APImageUpload);